import { lightenDarkenColor } from "./colorConvertor";
import { StylesConfig } from "react-select";
import { Theme } from "./theme";
import { Property } from "csstype";

const bg = (type) => {
  return type === "primary" ? "secondary" : "primary";
};

export default (
  theme: Theme,
  range: Range | null = null,
  belowValue = "primary",
  overPrimary,
  menuHeight,
  { containerWidth, menuPositionRelative }: RestProps = {}
): StylesConfig => ({
  container: (provided) => ({
    ...provided,
    width: containerWidth,
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? overPrimary
        ? "white"
        : theme.textOnPrimary
      : theme.text.secondary,
    fontSize: "0.8em",
    borderBottom: "1px solid " + theme.divider,
    background: state.isSelected
      ? overPrimary
        ? theme.primary
        : lightenDarkenColor(theme.primary, 30)
      : state.isFocused
      ? theme.background[bg(belowValue)]
      : theme.background[bg(belowValue)],
    "&:hover:not(.list__option--is-disabled)": {
      background: lightenDarkenColor(theme.primary, 30),
      color: theme.text.textOnPrimary,
    },
    opacity: state.isDisabled ? 0.5 : provided.opacity,
  }),
  control: (provided, state) => ({
    ...provided,
    margin: "0 1px",
    border: `1px solid ${range && range.notValidDate ? "red" : theme.divider}`,
    backgroundColor: overPrimary
      ? lightenDarkenColor(theme.primary, 14)
      : theme.background.primary,
    input: {
      opacity: "1 !important",
    },
    filter: state.isDisabled
      ? `brightness(${theme.disabledBackgroundBrightness})`
      : provided.filter,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: theme.text.secondary,
    background: overPrimary ? "none" : theme.background.primary,
    fontSize: "0.8em",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: overPrimary ? "white" : theme.text.secondary,
    fontSize: "0.8em",
  }),
  menu: (provided) => ({
    ...provided,
    background: theme.background[bg(belowValue)],
    color: theme.text.secondary,
    textAlign: "left",
    zIndex: 9999,
    position: menuPositionRelative ? "relative" : provided.position,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    background: overPrimary ? "white" : theme.text.secondary,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: theme.text.secondary,
    "&:hover": {
      color: overPrimary
        ? theme.textOnPrimary // Dark mode hover color
        : lightenDarkenColor(theme.text.secondary, 30), // Hover color for light mode
    },
  }),
  menuList: (provided) => ({
    ...provided,
    overflowX: "hidden",
    maxHeight: menuHeight ?? 200,
  }),
  input: (provided) => ({
    ...provided,
    color: overPrimary ? "white" : theme.text.secondary,
  }),
  group: (provided) => ({
    ...provided,
    marginLeft: 10,
  }),
  groupHeading: (provided) => ({
    ...provided,
    marginLeft: -10,
  }),
});

type Range = {
  notValidDate?: boolean;
};

type RestProps = {
  containerWidth?: Property.Width;
  menuPositionRelative?: boolean;
};
